import api from '@/api'

class LogService {
  addLog = async (bpId: number | null, logData: string, isFinal: boolean): Promise<void> => {
    await api.post(`businessProfiles/${bpId}/creativeLog`, { logData, isFinal })
  }
}

export default LogService
